/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
import React from "react";
import Media from "@qlik/qlik/src/components/Media";
import RichText from "@qlik/qlik/src/components/RichText";
import { getCardMedia } from "@qlik/qlik/src/lib/util/helpers";
import Cta from "@qlik/qlik/src/components/Cta";
import * as styles from "./styles.module.css";

const DesktopTabsScrollingSection = ({ data, sectionRefs, activeSection, handleLetterClick }) => {
    const { cardItems = [] } = data ?? {};
    return (
        <>
            <div className="col-12 md:col-4">
                <div className={`sticky top-35 ${styles.scrollTabs} `}>
                    {cardItems?.map((card) => {
                        const cardId = btoa(card.id).slice(0, 8);
                        return (
                            <div
                                key={card.id}
                                className={`mb-10 transition ${activeSection === cardId ? "active-tab" : ""}`}
                            >
                                <a
                                    className="hover:no-underline"
                                    href={`#${cardId}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleLetterClick(cardId);
                                    }}
                                >
                                    <p className="title-4 text-gray py-2.5 pl-6.75 border-l-3 border-gray-light/50 hover:text-green opacity-50 hover:opacity-100">
                                        {card.title}
                                    </p>
                                </a>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="col-12 md:col-8 lg:pl-22.25">
                {data?.cardItems?.map((card) => {
                    const cardId = btoa(card.id).slice(0, 8);
                    const cardImage = getCardMedia(card);
                    return (
                        // eslint-disable-next-line no-return-assign
                        <div
                            key={card.id}
                            ref={(el) => (sectionRefs.current[cardId] = el)}
                            id={cardId}
                            className="mb-[90px] scroll-mt-35"
                        >
                            <Media media={cardImage} className="w-full h-full object-cover mb-10 rounded" />
                            <h3 className=" mb-3.75">{card.subtitle}</h3>
                            {card.body && <RichText data={card} />}

                            {card?.cta && card?.cta?.length > 0 && (
                                <div className="mt-10 flex-col lg:flex-row ">
                                    <div className="flex items-center">
                                        {card?.cta?.map((ct) => (
                                            <Cta key={ct.id} data={ct} className="block mr-7.5" />
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default DesktopTabsScrollingSection;
